<template>
  <div
    class="speaker-card"
    role="button"
    tabindex="0"
    :aria-label="getFullName(speaker)"
    @click="onCardClick"
    @keypress.enter="onCardClick"
  >
    <!-- Photo -->
    <div class="speaker-card__avatar-wrap">
      <Avatar
        :image="speaker.profileImageUrl"
        :circle="true"
        :size="'full'"
        :name="getFullName(speaker)"
        :alt="$t('Views.Shared.UserPicture')"
        class="speaker-card__avatar"
      />
    </div>

    <!-- Info -->
    <div class="speaker-card__info">
      <h3 class="speaker-card__name">{{ getFullName(speaker) }}</h3>
      <p v-if="speaker.jobTitle" class="speaker-card__title">
        {{ speaker.jobTitle }}
      </p>
      <p v-if="speaker.Company" class="speaker-card__company">
        {{ speaker.Company }}
      </p>
    </div>
  </div>
</template>

<script>
import Avatar from '@/components/shared/Avatar';
import SpeakerInfoModal from '@/components/SpeakerInfoModal';

export default {
  name: 'SpeakerSection',
  components: { Avatar },
  props: {
    caption: { type: String, default: 'Speakers' },
    speaker: Object
  },
  methods: {
    getFullName(speaker) {
      return speaker && speaker.name + ' ' + speaker.lastName;
    },
    onCardClick() {
      document.body.classList.add('overflow-hidden');
      this.$modal.show(
        SpeakerInfoModal,
        { speaker: this.speaker },
        {
          width: '92%',
          height: 'auto',
          adaptive: true,
          minWidth: 300,
          maxWidth: 640
        },
        { closed: () => document.body.classList.remove('overflow-hidden') }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.speaker-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: box-shadow 0.2s, transform 0.15s;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  &__avatar-wrap {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 12px;
    flex-shrink: 0;
  }

  &__avatar {
    width: 80px;
    height: 80px;
  }

  &__info {
    width: 100%;
  }

  &__name {
    font-size: 14px;
    font-weight: 700;
    color: #111827;
    margin-bottom: 4px;
    line-height: 1.3;
  }

  &__title {
    font-size: 14px;
    color: #7a7a7a;
    margin-bottom: 2px;
    line-height: 1.4;
  }

  &__company {
    font-size: 14px;
    color: #7a7a7a;
    line-height: 1.4;
  }
}
</style>
